// Static content for M Media Corp

export const COMPANY = {
  name: "M Media Corp",
  short: "M MEDIA",
  ceo: "Meghan Amaral",
  ceoTitle: "CEO",
  email: "info@mmediacorp.com",
  social: "@MMEDIACORP",
  address: "620 Newport Center Dr., Suite #1100, Newport Beach, CA 92660",
  tagline: "Elevating Public Presence",
};

export const HERO_TICKER =
  "ELEVATING PUBLIC PRESENCE  ✦  PARTNERSHIP  ✦  HIGH-TOUCH SERVICE  ✦  EDITORIAL VISION  ✦  GLOBAL REACH  ✦";

export const SERVICES = [
  {
    slug: "marketing",
    number: "01",
    name: "Marketing & Branding",
    short: "Strategy that becomes signature.",
    items: [
      "Brand Strategy & Positioning",
      "Full-Service Advertising Agency",
      "Dedicated Branding Expert",
      "Click-Funnels & Ad Copywriting",
      "Digital Marketing Analysis & Strategy",
      "Paid Media Strategy & Management",
    ],
  },
  {
    slug: "creative",
    number: "02",
    name: "Creative",
    short: "Graphic, motion, art direction.",
    items: [
      "Graphic Design",
      "Video Editing & Post-Production",
      "Animation Services",
      "Music Composition",
      "Cover Frame Graphics",
      "Creative Production Writing",
    ],
  },
  {
    slug: "production",
    number: "03",
    name: "Production",
    short: "Cinema-grade photo & video.",
    items: [
      "Monthly Photo Shoots",
      "M Media Produced Videos",
      "Dedicated Videographer & Editor",
      "Voiceover Talent",
      "Glam Squad",
      "Teleprompter for Video Shoots",
    ],
  },
  {
    slug: "events",
    number: "04",
    name: "Events",
    short: "Curated, choreographed, unforgettable.",
    items: [
      "Event Planning",
      "Event Promotion",
      "Virtual Event Hosting & Production",
      "Brand Activations",
      "Premieres & Press Nights",
      "Talent Management On-site",
    ],
  },
  {
    slug: "talent",
    number: "05",
    name: "Talent",
    short: "Management for high-profile public figures.",
    items: [
      "Personal Brand Management",
      "Career Development",
      "Booking & Representation",
      "Press Coordination",
      "Speaker Bureau",
      "Corporate Talent Partnerships",
    ],
  },
  {
    slug: "social",
    number: "06",
    name: "Social",
    short: "Stories that engineer culture.",
    items: [
      "Full-Service Social Media Management",
      "Influencer Marketing Campaigns",
      "Carousel & Story Posts",
      "AI-Powered Content Personalization",
      "Monthly Data Analysis & Analytics",
      "Monthly Email Newsletter",
    ],
  },
  {
    slug: "film",
    number: "07",
    name: "Film",
    short: "Documentaries, TV shows, music videos.",
    items: [
      "TV Show Production",
      "Music Video Production",
      "Feature Film Development",
      "Documentary Production",
      "Distribution Strategy",
      "Festival Submissions",
    ],
  },
  {
    slug: "pr",
    number: "08",
    name: "Public Relations",
    short: "Top publicists, on retainer.",
    items: [
      "Media Relations",
      "Crisis Communications",
      "Online Reputation Management",
      "Press Releases & Wire Distribution",
      "Editorial Placements",
      "Award Submissions",
    ],
  },
  {
    slug: "app",
    number: "09",
    name: "Apps, Web & Software",
    short: "Native apps, web platforms, and corporate software — end-to-end.",
    items: [
      "iOS & Android App Development",
      "Website Design, Development & Management",
      "Interactive Web Design & UX",
      "Corporate Software Development",
      "E-commerce Strategy & Management",
      "SEO Services",
      "Holographic Skyline Advertising (Coming 2028)",
    ],
  },
];

export const WORK = [
  {
    id: "w1", slug: "enliven-medical",
    title: "Enliven Medical",
    category: "Brand Identity & PR",
    year: "2025",
    location: "Newport Beach · Los Angeles",
    img: "https://images.unsplash.com/photo-1763913603709-74997cc8a299?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    heroVideo: "https://customer-assets.emergentagent.com/job_brand-proposal-site/artifacts/6xj39pfr_news-conference-filming-an-event-with-a-video-camera-SBV-308950422-HD.mp4",
    midVideo: "https://customer-assets.emergentagent.com/job_brand-proposal-site/artifacts/oi71r2yi_elevated-cityscape-of-los-angeles-revealing-illuminated-skyline-downtown-skyscraper-SBV-354937341-HD.mp4",
    tagline: "A house-of-medicine, rewritten as a house-of-couture.",
    brief: "Enliven came to us as a respected boutique practice with a sterile, clinical identity that hid the artistry of its founders. We rebuilt the brand around the founders themselves — and seated them on every editorial roundtable that mattered.",
    deliverables: ["Brand Strategy & Positioning", "Identity System & Wordmark", "Founder PR Strategy", "Editorial Press Tour", "Founder Photography", "Crisis Comms Retainer", "Press-Day Activation"],
    results: [
      { n: "47", l: "Top-tier press placements" },
      { n: "12×", l: "Quarterly inbound consults" },
      { n: "$8.4M", l: "Earned media value" },
    ],
    press: ["Vogue", "Harper's Bazaar", "Robb Report", "GOOP", "InStyle", "Town & Country"],
    quote: { text: "M Media didn't just rebrand us. They walked us into rooms we never thought were ours to enter.", who: "Founders, Enliven Medical" },
    gallery: [
      "https://images.unsplash.com/photo-1763906471909-55c7898a32d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1768818565983-29d3f4d76869?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1776262144962-bb88a3281353?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    ],
  },
  {
    id: "w2", slug: "julia-post-jewelry",
    title: "Julia Post Jewelry",
    category: "Editorial Campaign",
    year: "2025",
    location: "Paris · New York",
    img: "https://images.unsplash.com/photo-1768818565983-29d3f4d76869?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    heroVideo: "/hero-loop.mp4",
    midVideo: "https://customer-assets.emergentagent.com/job_brand-proposal-site/artifacts/728gw0rf_printing-newspapers-in-typography-SBV-329702759-HD.mp4",
    tagline: "Heirlooms, shot as if they were the cover.",
    brief: "Julia Post makes one-of-one pieces for women who collect, not consume. We wrote the Volume 26 editorial — three cover-grade campaigns, a film, and the wholesale rollout into the houses that mattered.",
    deliverables: ["Editorial Art Direction", "Cover Campaign · 3 Stories", "Short Film (3:14)", "PR & Stylist Seeding", "E-commerce Strategy", "Wholesale Press Day"],
    results: [
      { n: "3", l: "Cover placements (B+H+T&C)" },
      { n: "$2.1M", l: "Q1 sell-through, first run" },
      { n: "28", l: "Editorial stylists looped in" },
    ],
    press: ["Vogue", "Harper's Bazaar", "Town & Country", "W Magazine", "Architectural Digest"],
    quote: { text: "I have never been spoken to like this by an agency. Like I was the brand, not a brief.", who: "Julia Post, Founder" },
    gallery: [
      "https://customer-assets.emergentagent.com/job_brand-proposal-site/artifacts/u74ga1sa_IMG_5230.jpeg",
      "https://images.unsplash.com/photo-1776262144962-bb88a3281353?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1709316131422-35a5fb1e9eb2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    ],
  },
  {
    id: "w3", slug: "maison-aurelle",
    title: "Maison Aurelle",
    category: "Film & Production",
    year: "2025",
    location: "Milan · Los Angeles",
    img: "https://images.unsplash.com/photo-1709316132030-5ae70fe4662f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    heroVideo: "https://customer-assets.emergentagent.com/job_brand-proposal-site/artifacts/yoqvr1jp_countdown-leader-picture-start-scan-of-archival-16mm-with-grain-and-texture-black-a-SBV-354559089-HD.mp4",
    midVideo: "https://customer-assets.emergentagent.com/job_brand-proposal-site/artifacts/se0t8ojf_los-angeles-cityscape-featuring-financial-district-skyscrapers-distant-urban-neighb-SBV-354864237-HD.mp4",
    tagline: "A 9-minute film that doubled their order book.",
    brief: "Maison Aurelle wanted a marketing video. We delivered a 9-minute film. It screened at private dinners, in Milan showrooms, and on a single full-page placement in W Magazine.",
    deliverables: ["Concept & Screenplay", "Director & Crew", "Two-City Shoot", "Original Score", "Festival Submission Strategy", "Distribution & Press"],
    results: [
      { n: "9:00", l: "Film runtime" },
      { n: "2×", l: "Order book in 90 days" },
      { n: "11", l: "Festival selections" },
    ],
    press: ["W Magazine", "Variety", "The Hollywood Reporter", "Wallpaper", "Document Journal"],
    quote: { text: "They made me a director without me realising. The film is mine. The film is them.", who: "Aurelle Vasari, House of Aurelle" },
    gallery: [
      "https://images.unsplash.com/photo-1763913603709-74997cc8a299?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1763906471909-55c7898a32d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1768818565983-29d3f4d76869?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    ],
  },
  {
    id: "w4", slug: "house-of-vela",
    title: "House of Vela",
    category: "Social & Influencer",
    year: "2024",
    location: "New York · London",
    img: "https://images.unsplash.com/photo-1763906471909-55c7898a32d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    heroVideo: "https://customer-assets.emergentagent.com/job_brand-proposal-site/artifacts/1a6tqz3b_night-panorama-of-the-city-SBV-353780195-HD.mp4",
    midVideo: "https://customer-assets.emergentagent.com/job_brand-proposal-site/artifacts/2v550kpo_establishment-shot-new-york-city-skyline-urban-business-district-SBV-305232997-HD.mp4",
    tagline: "Built the feed they pretend isn't a magazine.",
    brief: "Vela had product-market fit and no story. We rebuilt the social brand from voice to grid, ran a 6-month creator program with 14 talents, and tripled their conversion rate on a smaller spend.",
    deliverables: ["Social Strategy & Voice", "Editorial Grid System", "Creator Program · 14 Talents", "Always-On Carousel Production", "AI Personalisation Engine", "Weekly Editorial Newsletter"],
    results: [
      { n: "3.1×", l: "Conversion rate, paid social" },
      { n: "−42%", l: "CAC, in 90 days" },
      { n: "184k", l: "New owned subscribers" },
    ],
    press: ["Business of Fashion", "Vogue Business", "Glossy", "Fast Company"],
    quote: { text: "They run the feed like it's an editorial calendar. Which, it turns out, is the only way it works.", who: "Founder, House of Vela" },
    gallery: [
      "https://images.unsplash.com/photo-1709316131422-35a5fb1e9eb2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1776262144962-bb88a3281353?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1763913603709-74997cc8a299?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    ],
  },
  {
    id: "w5", slug: "atelier-noir",
    title: "Atelier Noir",
    category: "Talent Management",
    year: "2024",
    location: "Bicoastal",
    img: "https://images.unsplash.com/photo-1776262144962-bb88a3281353?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    heroVideo: "https://customer-assets.emergentagent.com/job_brand-proposal-site/artifacts/mij8cnw5_cinematic-aerial-view-of-modern-urban-city-buildings-black-and-white-SBV-349092029-HD.mp4",
    midVideo: "https://customer-assets.emergentagent.com/job_brand-proposal-site/artifacts/x8yjquew_approaching-lower-east-side-new-york-city-in-black-and-white-part-2-SBV-347121318-HD.mp4",
    tagline: "Six founders, one masthead. Booked solid.",
    brief: "Atelier Noir houses six founder-talents whose individual reach was capped by their own bandwidth. We placed them on a single shared masthead, ran an editorial booking desk, and tripled keynote, on-camera, and brand-partnership revenue.",
    deliverables: ["Talent Brand Architecture", "Personal Identity Systems", "Keynote & Booking Desk", "On-camera Coaching", "Press Coordination", "Brand Partnership Strategy"],
    results: [
      { n: "3.4×", l: "Combined talent revenue" },
      { n: "62", l: "Keynote bookings, year one" },
      { n: "9", l: "Brand-partnership retainers" },
    ],
    press: ["Forbes", "Inc.", "Vanity Fair", "Entertainment Weekly", "Bloomberg"],
    quote: { text: "I stopped doing my own emails on a Tuesday. By Friday I was on a Vanity Fair list.", who: "Talent, Atelier Noir" },
    gallery: [
      "https://images.unsplash.com/photo-1768818565983-29d3f4d76869?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1709316132030-5ae70fe4662f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1763906471909-55c7898a32d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    ],
  },
  {
    id: "w6", slug: "solene-skincare",
    title: "Solène Skincare",
    category: "App Development",
    year: "2024",
    location: "Los Angeles",
    img: "https://images.unsplash.com/photo-1709316131422-35a5fb1e9eb2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    heroVideo: "https://customer-assets.emergentagent.com/job_brand-proposal-site/artifacts/rnwdbtd4_cityscape-shot-of-futuristic-high-rise-metropolis-business-district-SBV-349095578-HD.mp4",
    midVideo: "https://customer-assets.emergentagent.com/job_brand-proposal-site/artifacts/oi71r2yi_elevated-cityscape-of-los-angeles-revealing-illuminated-skyline-downtown-skyscraper-SBV-354937341-HD.mp4",
    tagline: "An AI skincare companion, written like a magazine column.",
    brief: "Solène asked for an app. We delivered a daily editorial — an AI companion that diagnoses the skin, prescribes the ritual, and writes a personal column every morning. It out-ranked the entire category in App Store editorial.",
    deliverables: ["Product Strategy & UX", "iOS + Android Build", "AI Personalisation Engine", "Editorial Voice & CMS", "E-commerce & Subscriptions", "App Store Feature Strategy"],
    results: [
      { n: "1.2M", l: "App downloads, year one" },
      { n: "4.9 ★", l: "App Store rating" },
      { n: "$14.6M", l: "Subscription ARR" },
    ],
    press: ["Wired", "Fast Company", "Allure", "Glossy", "TechCrunch"],
    quote: { text: "It feels like Vogue and a dermatologist had a baby. Which is exactly what I asked for.", who: "Founder, Solène Skincare" },
    gallery: [
      "https://images.unsplash.com/photo-1763906471909-55c7898a32d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1763913603709-74997cc8a299?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1776262144962-bb88a3281353?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    ],
  },
];

export const TEAM = [
  { name: "Meghan Amaral", role: "Founder & CEO", img: "https://images.unsplash.com/photo-1763906471909-55c7898a32d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { name: "Isabella Marchetti", role: "Head of Editorial", img: "https://images.unsplash.com/photo-1763913603709-74997cc8a299?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { name: "Camille Reyes", role: "Director of Talent", img: "https://images.unsplash.com/photo-1776262144962-bb88a3281353?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { name: "Naomi Kestrel", role: "Head of PR", img: "https://images.unsplash.com/photo-1768818565983-29d3f4d76869?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { name: "Louis Tremaine", role: "Creative Director", img: "https://images.unsplash.com/photo-1709316131422-35a5fb1e9eb2?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { name: "Adira Sloane", role: "Director of Production", img: "https://images.unsplash.com/photo-1709316132030-5ae70fe4662f?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
];

export const POSTS = [
  {
    slug: "the-cover-story-method",
    title: "The Cover Story Method",
    excerpt: "A 90-day framework for turning a founder's personal narrative into the kind of feature an editor calls about — not the other way round.",
    author: "Team M Media",
    date: "Jun 18, 2026",
    category: "Strategy",
    img: "/journal/cover-story-method.jpg",
    body: [
      "Most founders try to 'get press'. The ones who land covers do something different: they build a single, defensible story arc that an editor cannot un-think once they have heard it. The Cover Story Method is the discipline of writing that arc on paper before a single pitch is sent.",
      "We start with a story spine — a contradiction. (\"A medical practice that operates like a couture house.\") We layer three pieces of evidence under it (data, anecdote, image), and we lock down three settings where the story can be photographed. Only then do we approach a publication, and we approach exactly one: the title we want to define the founder.",
      "The point is not the placement. The point is that every other publication then has a frame to follow. Once Vogue has called you a couture-house-of-medicine, Robb Report inherits the language. The first cover is the deed; the rest is the title transfer."
    ]
  },
  {
    slug: "earned-vs-paid-press",
    title: "Why Earned Press Still Beats Paid Press — Even in 2026",
    excerpt: "Paid placement gets you the page. Earned placement gets you the page, the social re-share, the search authority, and the second meeting.",
    author: "Team M Media",
    date: "May 22, 2026",
    category: "Public Relations",
    img: "/journal/earned-press.jpg",
    body: [
      "Sponsored content has matured. The disclosures are clearer, the formats are slicker, and there are seasons when a well-placed paid feature outperforms a thin editorial mention. But the comparison most founders make is the wrong one.",
      "Earned coverage compounds in four places paid coverage cannot: search results (because real editorial gets indexed by Google as authority), industry calendars (because awards committees recognise mastheads), the secondary press cycle (because real journalists cite other real journalists), and human trust (because every reader knows the difference, even when they say they don't).",
      "Use paid for product launches and time-bound activations. Use earned for who you are. Confuse the two and you spend a brand budget building a campaign and a campaign budget building a brand — and neither asset appreciates."
    ]
  },
  {
    slug: "founder-as-the-cover",
    title: "Why The Founder Should Be On The Cover",
    excerpt: "The case for putting the human first — and the product second — in every brand built after 2024.",
    author: "Team M Media",
    date: "Apr 14, 2026",
    category: "Brand",
    img: "/journal/founder-on-cover.jpg",
    body: [
      "Categories commoditise faster than they used to. Beauty, wellness, jewellery, even financial services — three years from launch, most products are interchangeable on paper. The variable that does not commoditise is the founder.",
      "A founder is the only asset on a brand's balance sheet that has a face, a voice, a backstory, and a point of view. The brands that win the next decade will be the ones that treat that asset like the headline, not the footnote.",
      "Practically: the founder appears in every campaign image, not just the About page. The founder has a quote in every press release. The founder owns the masthead of the newsletter. The founder is the call-to-action, even when the product is the offer."
    ]
  },
  {
    slug: "anatomy-of-an-editorial-placement",
    title: "Anatomy of an Editorial Placement",
    excerpt: "We dissect, line by line, what a top-tier feature actually contains — and how to engineer one that a senior editor will champion internally.",
    author: "Team M Media",
    date: "Feb 27, 2026",
    category: "Editorial",
    img: "/journal/anatomy-editorial.jpg",
    body: [
      "Open any cover-grade feature and you will find six recurring components: a contradiction in the lede, a domestic detail in the second paragraph, a quote that an editor wrote for the founder (not the other way round), a piece of proprietary data, an image that earns the page on its own, and a closing line that re-frames the entire field.",
      "If you cannot identify all six in your own brand's strongest story today, your pitch will fail — not because the writer disliked you, but because the deputy editor (the person who actually buys stories internally) cannot picture the layout.",
      "The work, then, is to build those six components before pitching. Photograph them. Quote-coach the founder. Pre-write the contradiction. Hand the writer a story they can immediately see on the page. That is what 'PR' actually means at this altitude."
    ]
  },
  {
    slug: "the-30-day-press-calendar",
    title: "The 30-Day Press Calendar",
    excerpt: "A four-week working rhythm — pitches Monday, photography Wednesday, embargoes Friday — that keeps a brand in the editorial conversation without burning the team out.",
    author: "Team M Media",
    date: "Jan 09, 2026",
    category: "Operations",
    img: "/journal/press-calendar.jpg",
    body: [
      "Most in-house teams pitch in bursts: a launch, a long silence, another launch. Top-tier agencies pitch in cycles. The difference is a 30-day press calendar, written six months in advance.",
      "Mondays are for outbound pitches — three per writer, max, to preserve relationship currency. Wednesdays are for in-house photography (so we are never asking an editor for a story with no imagery to anchor it). Fridays are for embargoed sends — the only respectful way to give a writer a head start.",
      "Quarterly we sit down with the founder, look at the calendar, and ask one question: which placement, if it lands, materially changes the next 12 months of revenue or recruiting? Everything else falls down the priority list. Calendars without prioritisation are wishlists."
    ]
  },
  {
    slug: "pitching-a-style-editor",
    title: "How to Pitch a Style Editor (And Why Most People Do It Wrong)",
    excerpt: "Pitches die in subject lines. Here's how the best are written — and what to put in the second sentence to keep an editor reading past the first.",
    author: "Team M Media",
    date: "Nov 14, 2025",
    category: "Public Relations",
    img: "/journal/pitch-style-editor.jpg",
    body: [
      "Style editors receive between 200 and 800 pitches a week. Roughly nine in ten are read on a phone, scrolling, in under three seconds. Your pitch lives or dies in the subject line and the first eleven words of the email.",
      "The strongest subject lines name a contradiction (\"the surgeon who only operates in candlelight\"), reference a fixed editorial slot (\"for Issue 27 — front of book?\"), or trade an asset (\"first-look images attached — exclusive 48hr\").",
      "In the body: lead with the photograph (one image, embedded, hero crop). Then the spine. Then the credit list. Save the founder bio and product details for the bottom — they are reference material, not narrative."
    ]
  },
  {
    slug: "fashion-week-for-founders",
    title: "Fashion Week for Founders: A Working Guide",
    excerpt: "When to fly in, who to know, which row to sit in, and what to do with the four days no one teaches you how to use.",
    author: "Team M Media",
    date: "Aug 21, 2025",
    category: "Events",
    img: "/journal/fashion-week.jpg",
    body: [
      "Fashion week is not a marketing channel. It is a 96-hour density experiment in which the publishing, retail, talent, and finance ecosystems of an industry all stand within walking distance of one another for the only time each season.",
      "If you are a founder, your job during fashion week is not to be photographed at the most shows. It is to take six private meetings the rest of the year would require six flights to schedule — and to do so in clothing that makes you legible from twenty feet away on a step-and-repeat.",
      "We routinely book founders into five strategic appointments and zero parties. They invariably do more business in a week than they could in a quarter. The signal that they are doing it right is that the press finds them anyway."
    ]
  },
  {
    slug: "crisis-pr-for-luxury",
    title: "Crisis PR for Luxury Brands",
    excerpt: "The first 90 minutes after a crisis breaks are the only ones that matter. Here is what we do — and what we never do — in that window.",
    author: "Team M Media",
    date: "May 03, 2025",
    category: "Public Relations",
    img: "/journal/crisis-pr.jpg",
    body: [
      "Crisis communications is the discipline most founders never want to retain and the one they regret not having on day one. Ninety percent of reputational damage in a luxury crisis happens in the first ninety minutes — before most agencies have even held their first internal call.",
      "Our standing protocol: an on-call senior partner reachable within seven minutes, a pre-approved holding statement library by category, and a press list that knows the brand well enough that they will hold a story for an hour if we ask politely.",
      "What we never do: deny something we have not yet verified, post a polished apology before a private one, or let the founder personally tweet anything in the first six hours. Crises are won by the brand that sounds calm — and calm always sounds slow at first."
    ]
  },
  {
    slug: "the-bicoastal-brand",
    title: "Building a Bicoastal Brand",
    excerpt: "Why every luxury brand still needs LA and New York — and what each city actually unlocks that the other never will.",
    author: "Team M Media",
    date: "Mar 11, 2025",
    category: "Strategy",
    img: "https://images.unsplash.com/photo-1444723121867-7a241cacace9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    body: [
      "Los Angeles makes celebrity. New York makes editorial. A bicoastal brand earns the right to one because it has already earned the other — and the order matters more than the addresses on the masthead.",
      "Brands that launch in LA and never cross the country read as celebrity-adjacent forever. Brands that launch in New York and never come west read as critically loved and commercially undersized. The brands that win the decade do both, in that order, within eighteen months.",
      "Our houseplay: open the New York bureau first, win the editorial backing, then activate LA for the cultural amplification. The brand keeps its critical credibility and earns the volume — without ever looking like it switched playbooks."
    ]
  },
  {
    slug: "social-as-editorial-calendar",
    title: "Treat Social Like an Editorial Calendar — Not a Content Mill",
    excerpt: "The brands winning on Instagram and TikTok in 2026 are not posting more. They are running their feeds like an issue of a magazine.",
    author: "Team M Media",
    date: "Jan 14, 2025",
    category: "Social",
    img: "/journal/social-editorial.jpg",
    body: [
      "We have stopped writing weekly social plans for our retainer clients. We write quarterly issues — twelve weeks of grid, planned to read as a single body of work, with three cover stories, a recurring column, and a back-of-book.",
      "The brands that adopt this stop competing for short-form attention and start cultivating long-form return. Their save rates triple. Their followers behave like subscribers. And they never again find themselves at 4pm on a Tuesday asking the intern what to post.",
      "If you are still writing a social plan inside a spreadsheet of dates and hashtags, you are running a content mill. If you are writing it inside a Pages document with sections and headlines, you are running a publication. Only one of those things appreciates."
    ]
  },
  {
    slug: "what-an-agency-retainer-actually-buys",
    title: "What a High-Touch Agency Retainer Actually Buys",
    excerpt: "Unpacking — line by line — what a $25k–$80k monthly retainer at a top media house should contain, and what it should never include.",
    author: "Team M Media",
    date: "Oct 02, 2024",
    category: "Practice",
    img: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    body: [
      "A high-touch retainer is not a list of deliverables. It is a guaranteed answer to four questions every Monday: what landed last week, what is moving this week, what is the founder pre-approving for next month, and what risk are we watching.",
      "It should include: a named senior strategist (not a pod), a press desk reachable in under two hours, monthly in-house photography, a quarterly editorial plan, two cover-track placements per year, and full crisis cover.",
      "It should never include: ghost-written social posts (those should be in-house), pay-to-play placements disguised as earned, junior staff sent to founder meetings, or any deliverable measured purely in volume. If you cannot read the retainer back to a peer and have them recognise it as luxury work, the retainer is the wrong one."
    ]
  },
  {
    slug: "the-giveback-thesis",
    title: "Why 10% Goes Back: The Giveback Thesis",
    excerpt: "On the editorial argument for putting a charitable share inside every client engagement — and the 18 causes M Media Corp is committed to.",
    author: "Team M Media",
    date: "Aug 14, 2024",
    category: "House",
    img: "/journal/giveback-thesis.jpg",
    body: [
      "Luxury that does not return something to the room is not luxury. It is consumption with better lighting. From the day we opened the house, ten percent of every client package has been routed to a curated list of organisations our team has personally vetted and worked alongside.",
      "We do not ask our clients to donate. We donate on their behalf, from our own margin, and we name them on the page — because the public record of who is supporting whom is part of what builds the cultural standing of a brand.",
      "Our current partners include Cancer Teamwork Response, the Elizabeth Taylor AIDS Foundation, Life After Love, the ASPCA, RAINN, Best Buddies, CHOC Foundation, Caterina's Club, Oceana, Global Fund for Women, I Support The Girls, Born This Way Foundation, Children of Persia, The Trevor Project, World Central Kitchen, Dress for Success, charity: water, and Pencils of Promise. Eighteen organisations in total. Every addition is a personal commitment built over time, never a press release."
    ]
  },
];

// ────────────────────────────────────────────────────────────
// CHARITY PARTNERS — 10% of every client package returns here
// ────────────────────────────────────────────────────────────
export const CHARITIES = [
  {
    name: "Cancer Teamwork Response",
    domain: "cancerteamworkresponse.org",
    url: "https://www.cancerteamworkresponse.org/",
    blurb: "Personalised patient guidance for families navigating a cancer diagnosis — coordinating second opinions, treatment logistics, and the human support that hospitals are not built to provide.",
    cause: "Cancer Support",
    theme: "health",
    logoSrc: "/charities/cancer-teamwork-response.png",
  },
  {
    name: "Elizabeth Taylor AIDS Foundation",
    domain: "elizabethtayloraidsfoundation.org",
    url: "https://elizabethtayloraidsfoundation.org/",
    blurb: "Funding direct care, prevention and advocacy for people most affected by HIV/AIDS — continuing the legacy of one of the boldest activists in entertainment.",
    cause: "Health · Advocacy",
    theme: "health",
  },
  {
    name: "ASPCA",
    domain: "aspca.org",
    url: "https://secure.aspca.org/donate/ps-gn-c-202606-p2",
    blurb: "Rescuing animals from cruelty and neglect, supporting shelters, and shaping the legislation that protects companion animals across the United States.",
    cause: "Animal Welfare",
    theme: "planet",
  },
  {
    name: "RAINN",
    domain: "rainn.org",
    url: "https://rainn.org/",
    blurb: "The nation's largest anti-sexual-violence organisation — operating the National Sexual Assault Hotline and championing survivor-centered policy.",
    cause: "Survivor Support",
    theme: "women",
  },
  {
    name: "Best Buddies International",
    domain: "bestbuddies.org",
    url: "https://www.bestbuddies.org/",
    logoSrc: "/charities/best-buddies.svg",
    blurb: "Building friendships, leadership programs, and inclusive employment opportunities for people with intellectual and developmental disabilities.",
    cause: "Inclusion",
    theme: "education",
  },
  {
    name: "CHOC Foundation",
    domain: "choc.org",
    url: "https://foundation.choc.org/give/",
    blurb: "Funding world-class paediatric care at Children's Hospital of Orange County — research, mental-health programs, and the families it never sends a bill to.",
    cause: "Children's Health",
    theme: "health",
  },
  {
    name: "Caterina's Club",
    domain: "caterinasclub.org",
    url: "https://caterinasclub.org/",
    blurb: "Feeding more than five thousand children every weeknight across Southern California, plus housing assistance and culinary training programs for families.",
    cause: "Hunger Relief",
    theme: "relief",
  },
  {
    name: "Oceana",
    domain: "oceana.org",
    url: "https://act.oceana.org/page/191945/donate/1",
    blurb: "The largest international advocacy organisation focused solely on ocean conservation — winning policy campaigns to restore fisheries and end plastic pollution.",
    cause: "Environment",
    theme: "planet",
  },
  {
    name: "Global Fund for Women",
    domain: "globalfundforwomen.org",
    url: "https://www.globalfundforwomen.org/",
    blurb: "Direct grants and movement support for women, girls, and trans-led organisations on the front lines of gender justice in more than 175 countries.",
    cause: "Women & Girls",
    theme: "women",
  },
  {
    name: "I Support The Girls",
    domain: "isupportthegirls.org",
    url: "https://isupportthegirls.org/",
    blurb: "Distributing bras, period products, and dignity to women and girls experiencing homelessness, displacement, or systemic poverty — globally.",
    cause: "Dignity & Health",
    theme: "women",
  },
  {
    name: "Born This Way Foundation",
    domain: "bornthisway.foundation",
    url: "https://bornthisway.foundation/",
    blurb: "Founded by Lady Gaga and her mother Cynthia — supporting youth mental wellness, kindness, and the right of every young person to be exactly who they are.",
    cause: "Youth Mental Health",
    theme: "youth",
  },
  {
    name: "Children of Persia",
    domain: "childrenofpersia.org",
    url: "https://www.childrenofpersia.org/",
    blurb: "Improving the lives of Iranian children — funding hospitals, schools, and humanitarian relief without political affiliation, for thirty years and counting.",
    cause: "Children · Global",
    theme: "youth",
  },
  {
    name: "Life After Love",
    domain: "lifeafterlove.org",
    url: "https://lifeafterlove.org/",
    blurb: "Together through grief, forward with hope. Supporting bereaved parents and surviving siblings — practical resources, therapeutic tools, financial grants, and a community that ensures no family navigates the loss of a child alone.",
    cause: "Grief & Healing",
    theme: "health",
    logoSrc: "/charities/life-after-love.png",
  },
  {
    name: "The Trevor Project",
    domain: "thetrevorproject.org",
    url: "https://www.thetrevorproject.org/",
    blurb: "The world's largest suicide-prevention and crisis-intervention organisation for LGBTQ young people — 24/7 lifelines, advocacy, and the research that backs both.",
    cause: "Youth · Crisis Care",
    theme: "youth",
  },
  {
    name: "World Central Kitchen",
    domain: "wck.org",
    url: "https://wck.org/donate",
    blurb: "Chef José Andrés' frontline meal response — feeding communities the day after disaster strikes, from hurricane zones to active conflict, with dignity at the centre of every plate.",
    cause: "Disaster Relief",
    theme: "relief",
  },
  {
    name: "Dress for Success",
    domain: "dressforsuccess.org",
    url: "https://dressforsuccess.org/get-involved/donate/",
    blurb: "Empowering women into economic independence through professional attire, interview coaching, and a global sisterhood of mentors that does not end at the office door.",
    cause: "Women's Empowerment",
    theme: "women",
  },
  {
    name: "charity: water",
    domain: "charitywater.org",
    url: "https://www.charitywater.org/donate",
    blurb: "Bringing clean and safe drinking water to people in developing countries — with the rare promise that 100% of public donations fund water projects, every penny tracked.",
    cause: "Clean Water",
    theme: "planet",
  },
  {
    name: "Pencils of Promise",
    domain: "pencilsofpromise.org",
    url: "https://pencilsofpromise.org/donate/",
    blurb: "Building schools and training teachers in Ghana, Guatemala, Laos and beyond — designing the kind of education the founders themselves would have wanted, one classroom at a time.",
    cause: "Education · Global",
    theme: "education",
  },
];

export const NAV = [
  { to: "/", label: "Index" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/studio", label: "Studio" },
  { to: "/journal", label: "Journal" },
  { to: "/give", label: "Give" },
  { to: "/matter", label: "M Matter" },
  { to: "/careers", label: "Careers" },
  { to: "/apply", label: "Apply" },
];

// Press / network logos — text-treatment marquee
export const PRESS_LOGOS = [
  "VOGUE", "Harper's Bazaar", "VANITY FAIR", "ELLE", "GQ", "ROLLING STONE",
  "Variety", "THE HOLLYWOOD REPORTER", "FORBES", "Bloomberg", "WSJ", "THE NEW YORK TIMES",
  "CNN", "NBC", "ABC", "CBS", "FOX", "BBC",
  "WIRED", "Architectural Digest", "W Magazine", "INTERVIEW", "Town & Country", "ROBB REPORT",
  "InStyle", "PEOPLE", "Entertainment Weekly", "BILLBOARD", "Deadline",
  "COSMOPOLITAN", "Marie Claire", "Glamour", "ALLURE", "TATLER",
  "Architectural Digest", "VOGUE BUSINESS", "BUSINESS OF FASHION", "FAST COMPANY", "INC.", "TIME",
];

// Faux scale / institutional partners line
export const PARTNERS = [
  "CANNES FILM FESTIVAL", "MET GALA", "ART BASEL", "PARIS FASHION WEEK", "MILAN DESIGN WEEK",
  "TIFF", "NYFW", "VENICE BIENNALE", "SUNDANCE", "FORBES UNDER 30", "DAVOS",
];

// Big-number proofs of scale
export const SCALE_NUMBERS = [
  { n: "120+", l: "Brands shaped" },
  { n: "$2.4B", l: "Combined audience reach" },
  { n: "9", l: "Disciplines, in-house" },
  { n: "100%", l: "Roster booked, by application" },
];

// Application stage options
export const STAGES = [
  "Founder · Pre-revenue",
  "Founder · Scaling",
  "Established Brand",
  "Public Figure / Talent",
  "Fortune 500 / Enterprise",
  "Investor / Family Office",
  "Other",
];

export const REVENUES = [
  "< $1M",
  "$1M – $5M",
  "$5M – $25M",
  "$25M – $100M",
  "$100M+",
  "Prefer not to say",
];

export const REFERRERS = [
  "Existing Client",
  "Industry Press",
  "Search",
  "Social",
  "Event / Conference",
  "Other",
];


// ────────────────────────────────────────────────────────────
// THE STUDIO — digital products, freebies, written deliverables
// 40 offerings across 6 tiers. All documents, no video/podcast.
// ────────────────────────────────────────────────────────────
export const OFFER_TIERS = [
  { id: "free",      label: "The Free Library", note: "Edited at the highest standard. Free, with attribution." },
  { id: "micro",     label: "Micro Editions",   note: "Single-sitting downloads. $1 – $9." },
  { id: "study",     label: "Studies & Templates", note: "Hands-on workbooks and swipe files. $19 – $67." },
  { id: "master",    label: "Briefings",        note: "Long-form written dossiers from the senior partners. $97 – $197." },
  { id: "signature", label: "The Intensives",   note: "Multi-volume written programs. Our flagship method. $297 – $497." },
  { id: "coaching",  label: "Coaching",         note: "Sixty minutes with Meghan Amaral. By the call." },
];

export const OFFERINGS = [
  // ─────────── FREE LIBRARY (15)
  { id: "f01", tier: "free", category: "Public Relations",
    title: "The Editor's Inbox — 50 Subject Lines That Open Magazines",
    promise: "The exact subject lines our publicists have used to crack Vogue, Vanity Fair, Robb Report, and Harper's Bazaar — annotated with why each works.",
    format: "32-page PDF", cta: "Download free", price: 0 },
  { id: "f02", tier: "free", category: "Branding",
    title: "Founder-as-the-Cover Worksheet",
    promise: "The 1-page exercise we walk every new client through to find the single editorial contradiction that becomes their brand spine.",
    format: "Printable PDF + fillable Notion template", cta: "Download free", price: 0 },
  { id: "f03", tier: "free", category: "Public Relations",
    title: "The 30-Day Press Calendar — Editable Template",
    promise: "Our exact internal weekly cadence: Monday pitches, Wednesday photography, Friday embargoes. Drop it into Notion or Google Calendar in five minutes.",
    format: "Notion + Google Sheets template", cta: "Download free", price: 0 },
  { id: "f04", tier: "free", category: "Social",
    title: "Editorial Grid System — 12-Tile Layout",
    promise: "Stop posting one-offs. Twelve tile-types that compose into a feed an editor would design — with placement rules.",
    format: "Figma file + Canva template", cta: "Download free", price: 0 },
  { id: "f05", tier: "free", category: "Crisis",
    title: "The First 90 Minutes — Crisis Holding-Statement Library",
    promise: "Six pre-approved holding statements (defective product, founder controversy, supplier scandal, social pile-on, legal threat, executive departure) you can adapt in under five minutes.",
    format: "Word + PDF", cta: "Download free", price: 0 },
  { id: "f06", tier: "free", category: "Branding",
    title: "The Quiet-Luxury Brand Audit",
    promise: "A 27-question self-assessment that scores your brand against the markers of true editorial credibility — and tells you which marker to fix first.",
    format: "Interactive PDF", cta: "Download free", price: 0 },
  { id: "f07", tier: "free", category: "Strategy",
    title: "100 Ways To Land Your First Cover",
    promise: "An obsessively researched directory of every legitimate path into a top-tier feature — broken down by founder profile and budget.",
    format: "84-page PDF", cta: "Download free", price: 0 },
  { id: "f08", tier: "free", category: "Public Relations",
    title: "40 Viral Hooks — Cover-Story Edition",
    promise: "Forty hook archetypes that have driven the highest-saved Instagram and TikTok posts we have ever produced for clients.",
    format: "Swipe-file PDF", cta: "Download free", price: 0 },
  { id: "f09", tier: "free", category: "Founder",
    title: "Founder Headshot Brief — The One-Pager",
    promise: "What we send to every photographer the day before a founder shoot. Wardrobe rules, lighting language, three shots to insist on.",
    format: "PDF brief", cta: "Download free", price: 0 },
  { id: "f10", tier: "free", category: "Events",
    title: "Fashion Week Founder's Pocket Guide",
    promise: "The four-day, city-by-city walking guide we hand our clients before NYFW, Paris, and Milan. Who to meet, which row to sit in, which dinners to skip.",
    format: "Mobile-optimised PDF", cta: "Download free", price: 0 },
  { id: "f11", tier: "free", category: "Talent",
    title: "Talent Partnership Term Sheet",
    promise: "The exact two-page term sheet our talent desk uses to lock in keynote and on-camera deals — fee floors, rider language, exclusivity clauses.",
    format: "Editable contract template", cta: "Download free", price: 0 },
  { id: "f12", tier: "free", category: "Strategy",
    title: "The Bicoastal Launch Checklist",
    promise: "Eighty-six items, sequenced, to take a brand from West Coast launch to East Coast editorial in under eighteen months.",
    format: "Notion checklist", cta: "Download free", price: 0 },
  { id: "f13", tier: "free", category: "Newsletter",
    title: "The Dossier — Weekly Editorial Newsletter",
    promise: "Every Sunday: one cover-grade story we are watching, one pitch that just landed, one tactic we are stealing for our own clients.",
    format: "Weekly email", cta: "Subscribe free", price: 0 },
  { id: "f14", tier: "free", category: "Writing",
    title: "The Founder's Voice Memos — 12 Drafts To Steal",
    promise: "Twelve fully-written first drafts you can adapt for your own audience this week: a launch announcement, a press response, a hiring note, a clienteling letter, and eight more.",
    format: "PDF · 28 pages", cta: "Download free", price: 0 },
  { id: "f15", tier: "free", category: "Social",
    title: "300 Content Ideas — Founder Reels & Short Form",
    promise: "Three hundred prompts, sorted by founder archetype (the technician, the maverick, the heir, the operator). No two are alike.",
    format: "PDF + Google Sheet", cta: "Download free", price: 0 },

  // ─────────── MICRO EDITIONS (5)
  { id: "m01", tier: "micro", category: "Workbook", price: 1,
    title: "The 2026 Editorial Gameplan — Workbook",
    promise: "A guided 24-page workbook that takes you from \"I want a cover this year\" to a fully scheduled pitch calendar in one weekend.",
    format: "Printable PDF", cta: "Add to cart" },
  { id: "m02", tier: "micro", category: "Workbook", price: 1,
    title: "Founder Voice — The Tone of Voice Worksheet",
    promise: "The four-axis exercise we use to extract a founder's authentic publishing voice, plus 20 worked examples from real client launches.",
    format: "Editable PDF", cta: "Add to cart" },
  { id: "m03", tier: "micro", category: "Template", price: 7,
    title: "The Press-Day Run-of-Show Template",
    promise: "The exact production document we hand every press-day team — minute-by-minute, role-by-role. Drop your brand on the cover and send.",
    format: "Google Docs + Word", cta: "Add to cart" },
  { id: "m04", tier: "micro", category: "Swipe File", price: 9,
    title: "80 Ways To Get Stylists To Pull Your Product",
    promise: "Eighty different outreach scripts, gift-suite tactics, and partnership angles for getting your product on a runway, in a shoot, or on a celebrity.",
    format: "Searchable PDF", cta: "Add to cart" },
  { id: "m05", tier: "micro", category: "Template", price: 9,
    title: "The Editorial Pitch — 12 Annotated Examples",
    promise: "Twelve real pitches that landed top-tier placements, with the editor's reply, and our breakdown of exactly why each one worked.",
    format: "PDF + Loom commentary", cta: "Add to cart" },

  // ─────────── STUDIES & TEMPLATES (8)
  { id: "s01", tier: "study", category: "Branding", price: 27,
    title: "The Brand Spine — Workbook + Worked Examples",
    promise: "Our internal positioning workbook. Five exercises, three case studies, one finished brand-spine document at the end.",
    format: "PDF workbook + 3 case studies", cta: "Add to cart" },
  { id: "s02", tier: "study", category: "Templates", price: 37,
    title: "Selling With Stories — The Conversion Stack",
    promise: "Forty-eight Instagram-story sequences engineered to move a follower from view to purchase without ever sounding like an ad.",
    format: "PDF playbook + Canva templates", cta: "Add to cart" },
  { id: "s03", tier: "study", category: "Templates", price: 47,
    title: "The Editorial Press Kit — Ready-to-Send",
    promise: "Six press-kit document types (founder bio, fact sheet, FAQ, press release, b-roll brief, image rider) — fully designed, just swap your details.",
    format: "InDesign + Google Slides + Word", cta: "Add to cart" },
  { id: "s04", tier: "study", category: "Workbook", price: 47,
    title: "Cover-Grade Founder Photography — A Working Guide",
    promise: "The end-to-end workflow for shooting a founder so that any publication can lift the imagery without retouching: wardrobe, lighting, poses, location.",
    format: "PDF guide + shot list + mood board", cta: "Add to cart" },
  { id: "s05", tier: "study", category: "Templates", price: 47,
    title: "The In-House Creative Director — Written Bootcamp",
    promise: "Twelve written modules teaching the producer-level skills our in-house creative team uses every day — without the agency overhead.",
    format: "PDF · 12 modules · ~120 pages · workbook", cta: "Add to cart" },
  { id: "s06", tier: "study", category: "Templates", price: 57,
    title: "Done-For-You Editorial Calendar — 90 Days",
    promise: "A ninety-day, pre-loaded social and PR calendar built around your brand spine. We do the strategy; you press publish.",
    format: "Notion workspace, pre-built", cta: "Add to cart" },
  { id: "s07", tier: "study", category: "Templates", price: 67,
    title: "Trial Reels — The Written Playbook + 30-Reel Library",
    promise: "Our exact trial-reels methodology, written end-to-end, plus a library of 30 fully scripted reel ideas (hook, on-screen text, action, audio cue) you can shoot tomorrow.",
    format: "PDF playbook · 96 pages · 30 reel scripts", cta: "Add to cart" },
  { id: "s08", tier: "study", category: "Templates", price: 67,
    title: "The Newsletter Operating System",
    promise: "Build a luxury weekly newsletter from scratch — voice, sections, growth, monetisation — using the same OS we use for The Dossier.",
    format: "PDF playbook · 112 pages · Notion OS · 24 issue templates", cta: "Add to cart" },

  // ─────────── BRIEFINGS (6)
  { id: "x01", tier: "master", category: "Public Relations", price: 97,
    title: "Pitching Editors — The 84-Page Field Manual",
    promise: "Anatomy of a great pitch, dissected line by line, with three real annotated pitches sent in 2025 and the editor's replies in full.",
    format: "PDF · 84 pages · 3 annotated pitches", cta: "Add to cart" },
  { id: "x02", tier: "master", category: "Branding", price: 127,
    title: "Building the Founder-Led Brand — The Briefing",
    promise: "Why the next decade belongs to founders who behave like editors-in-chief — and the written operating system for becoming one.",
    format: "PDF dossier · 96 pages · workbook", cta: "Add to cart" },
  { id: "x03", tier: "master", category: "Crisis", price: 147,
    title: "Crisis PR for Luxury Brands — Three Case Files",
    promise: "Walk through three real (anonymised) crises that hit our retainer clients in 2024–25, the exact decisions hour by hour, every holding statement, every internal memo.",
    format: "PDF · 3 case files · 120 pages total", cta: "Add to cart" },
  { id: "x04", tier: "master", category: "Talent", price: 147,
    title: "Making The Founder Famous — Without Selling Out",
    promise: "The dossier on personal positioning for founders who want recognition without commoditising themselves into a content creator.",
    format: "PDF dossier · 88 pages · 40 self-positioning prompts", cta: "Add to cart" },
  { id: "x05", tier: "master", category: "Production", price: 167,
    title: "Cinema-Grade Founder Films — The Production Field Guide",
    promise: "Our Director of Production opens the playbook on producing the 3- to 9-minute films that have replaced traditional brand campaigns — every brief, every shot list, every crew tier sheet.",
    format: "PDF · 132 pages · shot lists · crew tier sheet", cta: "Add to cart" },
  { id: "x06", tier: "master", category: "Strategy", price: 197,
    title: "The Editor Behind Every Founder — The Big Briefing",
    promise: "Our flagship written briefing: how to run your founder communications like a publication, with quarterly issues, columns, and front-of-book pieces.",
    format: "PDF · 168 pages · annual editorial template", cta: "Add to cart" },

  // ─────────── THE INTENSIVES (4)
  { id: "g01", tier: "signature", category: "Program", price: 297,
    title: "The Cover Story Method™ — 8-Volume Intensive",
    promise: "Our complete written process for engineering a top-tier cover placement, delivered as eight volumes with workbooks, templates, and pitch examples. Self-paced, lifetime access.",
    format: "8 PDF volumes · ~280 pages · workbooks · templates", cta: "Add to cart" },
  { id: "g02", tier: "signature", category: "Program", price: 347,
    title: "Leveraged Income with Editorial PR — The 10-Volume Program",
    promise: "For solo founders and small teams: how to turn one cover-grade story into nine months of compounding inbound and revenue. Fully written, no live sessions required.",
    format: "10 PDF volumes · ~320 pages · email templates", cta: "Add to cart" },
  { id: "g03", tier: "signature", category: "Program", price: 397,
    title: "AI for Founder Communications — The Written Intensive",
    promise: "Practical, agency-grade written workflows for using AI to write, photograph, pitch, and publish without ever sounding like AI. Includes our full prompt library.",
    format: "9 PDF volumes · ~300 pages · 400-prompt library", cta: "Add to cart" },
  { id: "g04", tier: "signature", category: "Program", price: 497,
    title: "The Bicoastal Brand — The Six-Volume Intensive",
    promise: "Our written intensive on operating a luxury brand across LA and New York — when to open, who to hire, which editors to seat first. Includes our actual introduction templates.",
    format: "6 PDF volumes · ~240 pages · network templates", cta: "Add to cart" },

  // ─────────── PRIVATE COUNCIL (2)
  { id: "p01", tier: "private", category: "Coaching", price: 997,
    title: "The Hour With Meghan — Private Strategy Call",
    promise: "Sixty minutes, on the record, with Meghan Amaral on your single highest-leverage editorial question. Recording, transcript, action list delivered within 48 hours.",
    format: "1 × 60 min call · written follow-up", cta: "Book" },
  { id: "p02", tier: "private", category: "Coaching", price: 4800,
    title: "The Quarterly Council",
    promise: "A 90-day private retainer-lite — three calls with the senior partners, monthly editorial reviews, and direct WhatsApp access to your designated principal.",
    format: "3 × 60 min calls + 90 days messaging", cta: "Apply" },

  // ═══════════════════════════════════════════════════════════
  //  EXPANSION — 60 ADDITIONAL OFFERINGS (Subjects: social, viral,
  //  shoot prep, behind-the-scenes → face, podcast, PR, trends/hooks,
  //  branding, events, executive presence, executive comms, marketing
  //  investment, advertising, paid ads, AI for growth)
  // ═══════════════════════════════════════════════════════════

  // ─────────── SOCIAL MEDIA — everything social
  { id: "f16", tier: "free", category: "Social Media", price: 0,
    title: "100 Founder Social Hooks — The Library",
    promise: "One hundred opening lines, organised by intent (save, share, click, buy), that have driven the highest-saved posts our retainer clients ever published.",
    format: "PDF · 24 pages", cta: "Download free" },
  { id: "f17", tier: "free", category: "Social Media", price: 0,
    title: "The Anti-Algorithm Posting Calendar",
    promise: "A 30-day calendar that posts to humans, not algorithms — what to publish on which day, on which platform, with which intent.",
    format: "PDF + editable Notion", cta: "Download free" },
  { id: "s09", tier: "study", category: "Social Media", price: 27,
    title: "The Social Audit — Founder Edition",
    promise: "A 48-question audit that scores your Instagram, TikTok, LinkedIn, and newsletter against the markers of founder-led editorial credibility — and tells you which to fix first.",
    format: "PDF · 56 pages · scorecard", cta: "Add to cart" },
  { id: "s10", tier: "study", category: "Social Media", price: 47,
    title: "Platform-by-Platform Playbook (Instagram · TikTok · LinkedIn · Substack)",
    promise: "Four written platform playbooks in one pack. Voice rules, format rules, cadence rules, growth rules, ad-against-yourself rules — written for founders, not creators.",
    format: "4 PDF playbooks · 160 pages total", cta: "Add to cart" },

  // ─────────── GO VIRAL
  { id: "f18", tier: "free", category: "Viral", price: 0,
    title: "The 12 Viral Story Structures",
    promise: "Twelve narrative structures behind every post that has ever gone viral in the luxury/founder lane — diagrammed, with two examples each.",
    format: "PDF · 32 pages", cta: "Download free" },
  { id: "f19", tier: "free", category: "Viral", price: 0,
    title: "Anatomy of a Viral Post — 6 Posts Annotated",
    promise: "Six real posts that hit 2M+ views in 2024–25, broken down second by second: what worked, what almost killed it, what to steal.",
    format: "PDF · 40 pages", cta: "Download free" },
  { id: "s11", tier: "study", category: "Viral", price: 37,
    title: "Going Viral Without Selling Out",
    promise: "The written playbook for founders who want reach without becoming a content creator: voice rules, taste filters, and the 'one wild post a month' protocol.",
    format: "PDF · 72 pages · audit + 30 examples", cta: "Add to cart" },
  { id: "x07", tier: "master", category: "Viral", price: 127,
    title: "The Hooks Bible — 200 Formulas",
    promise: "Two hundred hook formulas with annotation, archetype tagging, and a stack-and-combine appendix that lets you compose new hooks from proven parts.",
    format: "PDF · 144 pages · stack appendix", cta: "Add to cart" },

  // ─────────── PHOTOSHOOTS · ON-CAMERA · SHOOT DAY
  { id: "f20", tier: "free", category: "Shoot Prep", price: 0,
    title: "The Founder Shoot Day Checklist",
    promise: "T–14 to T+1 — every item, every responsibility, every snack. The exact checklist our producers print and tape to the wall.",
    format: "PDF · 8 pages · print-ready", cta: "Download free" },
  { id: "f21", tier: "free", category: "On-Camera", price: 0,
    title: "Speaking On Camera — 7-Step Prep",
    promise: "The seven-step warm-up our talent desk walks founders through 90 minutes before any camera rolls. Voice, posture, eyes, breath.",
    format: "PDF · 10 pages", cta: "Download free" },
  { id: "s12", tier: "study", category: "On-Camera", price: 37,
    title: "The On-Camera Founder — Voice & Presence Workbook",
    promise: "A 16-exercise written workbook for founders who want to stop sounding like they are giving a presentation. Same drills our voice coach uses, 1:1, in private.",
    format: "PDF workbook · 60 pages · 16 exercises", cta: "Add to cart" },
  { id: "s13", tier: "study", category: "Production", price: 47,
    title: "The Press Day Production Pack",
    promise: "Run-of-show, shot list, wardrobe brief, glam brief, vendor list, and the founder's own mood-board — six documents, fully designed, ready to send.",
    format: "6 PDF + editable Word", cta: "Add to cart" },

  // ─────────── BEHIND-THE-SCENES → FACE OF THE BUSINESS
  { id: "f22", tier: "free", category: "Founder", price: 0,
    title: "Coming Out From Behind the Curtain — 30-Day Plan",
    promise: "For the founder who built the business in private and now needs to step into it publicly: 30 small, sequenced moves that compound without overwhelm.",
    format: "PDF · 22 pages", cta: "Download free" },
  { id: "f23", tier: "free", category: "Founder", price: 0,
    title: "Founder Headshot Brief 2.0 — The Public Version",
    promise: "The headshot brief for the founder who is now going to be the brand. Wardrobe, gaze, light, gesture — calibrated for legibility from across a room.",
    format: "PDF · 8 pages", cta: "Download free" },
  { id: "s14", tier: "study", category: "Founder", price: 47,
    title: "The Operator-to-Face Transition Playbook",
    promise: "A written 90-day program for the founder who has run the business from a desk and now needs to be the brand. Voice, comms cadence, public schedule, exit doors.",
    format: "PDF · 88 pages · workbook", cta: "Add to cart" },
  { id: "x08", tier: "master", category: "Founder", price: 147,
    title: "The Public Founder — A 90-Day Reset",
    promise: "A 110-page briefing for the founder making the irreversible move from background to foreground — including how to bring the team and the partners with you.",
    format: "PDF briefing · 110 pages", cta: "Add to cart" },

  // ─────────── PODCAST — starting one
  { id: "f24", tier: "free", category: "Podcast", price: 0,
    title: "Should You Start A Podcast? — 27-Question Audit",
    promise: "A blunt self-audit. If you score below 18, the answer is no — yet. If you score above, here are the next five moves before episode one.",
    format: "PDF · 14 pages · scorecard", cta: "Download free" },
  { id: "f25", tier: "free", category: "Podcast", price: 0,
    title: "The First 5 Episodes — Outline Pack",
    promise: "Five fully outlined episode arcs (cold open, three acts, close, show notes) for a founder-led luxury podcast. Adapt the names, keep the bones.",
    format: "PDF · 18 pages", cta: "Download free" },
  { id: "s15", tier: "study", category: "Podcast", price: 47,
    title: "How To Start A Luxury Podcast — The Written Playbook",
    promise: "Everything we wish we had been told before launching The Dossier-era podcasts: positioning, recording, post, distribution, monetisation. Written, no fluff.",
    format: "PDF · 96 pages", cta: "Add to cart" },
  { id: "s16", tier: "study", category: "Podcast", price: 57,
    title: "The Podcast Launch Pack — 24 Documents",
    promise: "Twenty-four fully designed launch documents: pitch deck for guests, recording prep brief, release calendar, sponsor sheet, press release, every email template.",
    format: "24 docs · PDF + editable", cta: "Add to cart" },

  // ─────────── EVERYTHING PR
  { id: "f26", tier: "free", category: "PR", price: 0,
    title: "PR Glossary for Founders — 120 Terms",
    promise: "The 120 terms your publicist uses that nobody explains. Cover line, embargo, kicker, pickup, par, B-roll, evergreen — all defined, in plain English.",
    format: "PDF · 36 pages · index", cta: "Download free" },
  { id: "f27", tier: "free", category: "PR", price: 0,
    title: "DIY Press Release Library — 12 Templates",
    promise: "Twelve press-release templates for the moments a founder is most likely to need one: launch, hiring, partnership, milestone, crisis, departure, and seven more.",
    format: "12 templates · Word + Google Docs", cta: "Download free" },
  { id: "s17", tier: "study", category: "PR", price: 47,
    title: "The Self-Service PR Bible — For Founders Without An Agency",
    promise: "The entire playbook for founders who cannot yet afford an in-house PR team or a retainer — written so you can do it yourself, at full editorial standard.",
    format: "PDF · 128 pages · 30 templates", cta: "Add to cart" },
  { id: "x09", tier: "master", category: "PR", price: 167,
    title: "The 12-Month PR Calendar — Written Briefing",
    promise: "A 120-page written briefing that takes you, month-by-month, through 12 months of a full editorial PR programme: pitches, embargoes, photography, partnerships.",
    format: "PDF · 120 pages · pre-loaded calendar", cta: "Add to cart" },

  // ─────────── TRENDS & VIRAL HOOKS
  { id: "f28", tier: "free", category: "Trends", price: 0,
    title: "Trends to Steal in Q1 2026",
    promise: "Twelve aesthetic, voice, and format trends from the luxury & culture worlds that founders can adapt without looking like they are following anything.",
    format: "PDF · 30 pages", cta: "Download free" },
  { id: "f29", tier: "free", category: "Hooks", price: 0,
    title: "60 Cover-Line Formulas",
    promise: "Sixty cover-line patterns lifted from a decade of top-tier magazines, retro-engineered, and ready for your captions, subject lines, and headlines.",
    format: "PDF · 20 pages", cta: "Download free" },
  { id: "s18", tier: "study", category: "Hooks", price: 47,
    title: "The Hook Bible — 200 Annotated Formulas",
    promise: "Two hundred hook formulas, every one annotated, every one tested on real founder accounts. The single most-used document inside our retainer team.",
    format: "PDF · 132 pages · index", cta: "Add to cart" },
  { id: "s19", tier: "study", category: "Trends", price: 47,
    title: "The Trend Forecasting Field Manual",
    promise: "A written field manual for spotting, scoring, and adopting trends before your competitors — without ever looking like you are chasing them.",
    format: "PDF · 88 pages · scorecard", cta: "Add to cart" },

  // ─────────── BRANDING & AESTHETICS
  { id: "f30", tier: "free", category: "Branding", price: 0,
    title: "The 1-Page Mood Board Discipline",
    promise: "A single-page exercise for moving from 'I want it to feel premium' to a concrete, communicable aesthetic that designers can execute.",
    format: "PDF · 4 pages", cta: "Download free" },
  { id: "f31", tier: "free", category: "Branding", price: 0,
    title: "Type Pairings For Luxury Brands",
    promise: "Twenty four font pairings, in real layouts, with notes on why each one works and where it belongs. Bebas + Cormorant, GT America + Garamond, more.",
    format: "PDF · 32 pages", cta: "Download free" },
  { id: "s20", tier: "study", category: "Branding", price: 57,
    title: "The Brand Aesthetic Bible Template",
    promise: "A fillable 60-page brand aesthetic bible: palette, typography, photography, motion, voice, do/don't grids. The kind of document a head of brand spends a quarter writing.",
    format: "PDF + Figma + Notion", cta: "Add to cart" },
  { id: "x10", tier: "master", category: "Branding", price: 167,
    title: "Visual Identity From Scratch — The Briefing",
    promise: "A 116-page written briefing on building a visual identity that scales from a logo through a magazine spread. Real examples, real before-and-afters.",
    format: "PDF · 116 pages · case studies", cta: "Add to cart" },

  // ─────────── EVENT PLANNING
  { id: "f32", tier: "free", category: "Events", price: 0,
    title: "Editorial Dinner Playbook — Eight Seats",
    promise: "The exact playbook we use when our retainer clients ask us to host an eight-seat dinner that lands as an editorial moment — guest list, room, menu, gifting.",
    format: "PDF · 26 pages", cta: "Download free" },
  { id: "f33", tier: "free", category: "Events", price: 0,
    title: "The Launch Event Run-of-Show",
    promise: "The minute-by-minute run-of-show document we send our production team for every brand launch event we have run since 2022.",
    format: "PDF + Google Sheet", cta: "Download free" },
  { id: "s21", tier: "study", category: "Events", price: 47,
    title: "Event Production Kit — The Luxury Dinner",
    promise: "All twelve documents we use to produce a luxury dinner: budget tracker, vendor list, seating diagram, gifting brief, photography brief, press list, follow-up letter.",
    format: "12 docs · PDF + editable", cta: "Add to cart" },
  { id: "s22", tier: "study", category: "Events", price: 47,
    title: "The Hosted Salon Bible — Quarterly Founder Salons",
    promise: "A written field manual for running a recurring, in-person, invitation-only founder salon. Cadence, invitations, format, post-event ritual, monetisation.",
    format: "PDF · 92 pages", cta: "Add to cart" },

  // ─────────── LOOK THE PART — ONLINE AND IN PERSON
  { id: "f34", tier: "free", category: "Image", price: 0,
    title: "The Founder's Wardrobe Capsule — Twelve Pieces",
    promise: "The twelve-piece wardrobe capsule our talent desk recommends to founders shooting cover-grade imagery and walking into editor breakfasts in the same week.",
    format: "PDF · 18 pages", cta: "Download free" },
  { id: "f35", tier: "free", category: "Image", price: 0,
    title: "On-Screen Presence Checklist",
    promise: "A 27-point checklist for the founder about to go on camera: lighting, lens height, eyeline, posture, breath, hands, audio, background.",
    format: "PDF · 6 pages · print-ready", cta: "Download free" },
  { id: "s23", tier: "study", category: "Image", price: 47,
    title: "Personal Image Architecture — The Founder's Book",
    promise: "A 100-page written guide to building a personal image — wardrobe, grooming, posture, voice, vocabulary — that holds up across every public surface.",
    format: "PDF · 100 pages", cta: "Add to cart" },
  { id: "s24", tier: "study", category: "Image", price: 57,
    title: "The Editorial Presence Manual",
    promise: "The written manual for showing up — in a green room, on a stage, in a magazine, on a screen — with a presence editors and audiences both remember.",
    format: "PDF · 124 pages", cta: "Add to cart" },

  // ─────────── SEND LIKE AN EXECUTIVE
  { id: "f36", tier: "free", category: "Executive Comms", price: 0,
    title: "The 8 Executive Email Templates",
    promise: "Eight written email templates that sound like an executive: the decline, the introduction, the follow-up, the apology, the hire, the kill, the gratitude, the close.",
    format: "PDF · 18 pages", cta: "Download free" },
  { id: "f37", tier: "free", category: "Executive Comms", price: 0,
    title: "How To Reply Like The CEO",
    promise: "Twelve principles for replying to email the way a senior leader does — brevity, posture, time-cost, what to never apologise for, when to wait.",
    format: "PDF · 14 pages", cta: "Download free" },
  { id: "s25", tier: "study", category: "Executive Comms", price: 37,
    title: "Founder Comms — Written Style Guide",
    promise: "The exact written style guide we hand new clients for their internal and external communications: voice, structure, vocabulary, what to never write.",
    format: "PDF · 64 pages", cta: "Add to cart" },
  { id: "s26", tier: "study", category: "Executive Comms", price: 47,
    title: "The Internal Memo Library — 24 Templates",
    promise: "Twenty-four pre-written internal memos covering the moments founders most underwrite: hiring, firing, change of direction, board updates, team-wide thank-yous.",
    format: "24 memos · PDF + Word", cta: "Add to cart" },

  // ─────────── INVESTING IN YOUR MARKETING
  { id: "f38", tier: "free", category: "Marketing", price: 0,
    title: "Marketing Budget Framework For Founders",
    promise: "A 6-axis framework for deciding how much to spend, on what, for what return — written for founders who do not yet have a CFO.",
    format: "PDF · 22 pages · sheet", cta: "Download free" },
  { id: "f39", tier: "free", category: "Marketing", price: 0,
    title: "The 80/20 of Marketing Spend",
    promise: "The twenty percent of marketing levers that drive eighty percent of the return — for luxury, founder-led brands — backed by the spend ratios we see in our retainer book.",
    format: "PDF · 18 pages", cta: "Download free" },
  { id: "x11", tier: "master", category: "Marketing", price: 167,
    title: "The Marketing Investment Playbook — The Briefing",
    promise: "A 110-page written briefing on how to invest in marketing the way a senior CMO would, including the four spend traps every founder falls into before $10M ARR.",
    format: "PDF briefing · 110 pages", cta: "Add to cart" },
  { id: "s27", tier: "study", category: "Marketing", price: 47,
    title: "ROI Diagnostics — The Founder's Spreadsheet",
    promise: "A pre-built diagnostic sheet for evaluating which of your marketing line items are actually working — by channel, by campaign, by quarter.",
    format: "PDF + Google Sheet", cta: "Add to cart" },

  // ─────────── TYPES OF ADVERTISING
  { id: "f40", tier: "free", category: "Advertising", price: 0,
    title: "Advertising Glossary For Founders",
    promise: "Ninety-six terms — CPM, CPC, CAC, OOH, programmatic, native, attribution, halo — all defined, with whether your brand should care.",
    format: "PDF · 28 pages", cta: "Download free" },
  { id: "f41", tier: "free", category: "Advertising", price: 0,
    title: "OOH, Print, Digital — Side-by-Side",
    promise: "A clean comparison sheet of the three classical ad channels for luxury brands: cost, reach, prestige, half-life, what to use when.",
    format: "PDF · 12 pages", cta: "Download free" },
  { id: "s28", tier: "study", category: "Advertising", price: 47,
    title: "The Channel Selection Playbook",
    promise: "A written framework for choosing the right ad channels for a founder-led luxury brand by stage, category, and ambition. Includes 24 worked examples.",
    format: "PDF · 88 pages", cta: "Add to cart" },
  { id: "s29", tier: "study", category: "Advertising", price: 57,
    title: "Advertising For Luxury — Field Guide",
    promise: "An end-to-end written field guide on running advertising for a luxury brand without diluting the brand — what to never advertise, where to never appear.",
    format: "PDF · 104 pages", cta: "Add to cart" },

  // ─────────── PAID ADS
  { id: "f42", tier: "free", category: "Paid Ads", price: 0,
    title: "The Founder's First $1,000 In Paid Ads",
    promise: "An exact $1,000 starter plan: which platforms, which formats, which audiences, which creatives — for a founder-led brand running its first paid test.",
    format: "PDF · 16 pages", cta: "Download free" },
  { id: "f43", tier: "free", category: "Paid Ads", price: 0,
    title: "Meta vs Google For Luxury — The Decision Tree",
    promise: "A simple decision tree for deciding where to put your first ad dollar based on category, AOV, and audience habit. With three real ratio examples.",
    format: "PDF · 10 pages", cta: "Download free" },
  { id: "s30", tier: "study", category: "Paid Ads", price: 57,
    title: "Paid Ads For Founder-Led Brands",
    promise: "The written playbook for running paid acquisition without compromising founder-brand voice — including creative briefs, anti-template templates, and reporting layouts.",
    format: "PDF · 112 pages", cta: "Add to cart" },
  { id: "g05", tier: "signature", category: "Paid Ads", price: 397,
    title: "Creative For Performance Ads — The Intensive",
    promise: "A multi-volume written intensive on producing performance-grade ad creative that still feels like editorial. Includes 60 production-ready creative briefs.",
    format: "6 PDF volumes · ~220 pages · 60 briefs", cta: "Add to cart" },

  // ─────────── AI FOR BUSINESS GROWTH
  { id: "f44", tier: "free", category: "AI", price: 0,
    title: "20 AI Prompts For Founders Today",
    promise: "Twenty production-ready prompts every founder can use this week — pitch writing, founder voice, audit, response drafts, hiring brief, crisis triage.",
    format: "PDF · 22 pages", cta: "Download free" },
  { id: "f45", tier: "free", category: "AI", price: 0,
    title: "The 2026 AI Tool Stack — Curated",
    promise: "The exact AI tools our in-house team actually uses every week, what we use each one for, and which ones not to bother with this year.",
    format: "PDF · 18 pages", cta: "Download free" },
  { id: "s31", tier: "study", category: "AI", price: 67,
    title: "The AI Prompt Library For Founder Communications",
    promise: "Two hundred and forty production-ready prompts, organised by communication scenario: press, social, internal, sales, hiring, founder voice, crisis.",
    format: "PDF · 96 pages · 240 prompts", cta: "Add to cart" },
  { id: "g06", tier: "signature", category: "AI", price: 497,
    title: "The AI Founder Operating System — The Intensive",
    promise: "A multi-volume written intensive on installing AI across the founder's day-to-day operations — and the lines you must not cross. Includes 320 prompts.",
    format: "7 PDF volumes · ~260 pages · 320 prompts", cta: "Add to cart" },

  // ─────────── COACHING (the one product that requires Meghan in person)
  { id: "c01", tier: "coaching", category: "Coaching", price: 997, kind: "coaching",
    title: "Sixty Minutes With Meghan — Strategy Call",
    promise: "A one-hour private Zoom with Meghan Amaral, founder of M Media Corp. Bring your toughest question — pitch, positioning, press strategy, founder-brand split, crisis triage — and walk away with a written action plan in your inbox the same day.",
    format: "60-minute Zoom · written action plan included", cta: "Book the call" },
];
